import { __extends } from "tslib";
import { TaskBaseWebGL } from './webgl/TaskBaseWebgGL';
var BlurTask = /** @class */ (function (_super) {
    __extends(BlurTask, _super); /*Filter3DTaskBase*/
    /**
     * @param kernel The maximum amount of blur to apply in pixels at the most out-of-focus areas
     * @param horizonal Pass direction
     */
    function BlurTask(kernel, horizonal) {
        if (horizonal === void 0) { horizonal = true; }
        var _this = _super.call(this) || this;
        _this.horizontalPass = true;
        _this._clampedKernel = 0;
        _this._kernel = 0;
        _this._realStepSize = 1;
        _this._stepSize = -1;
        _this.imageScale = 1;
        _this.kernel = kernel;
        _this._data = new Float32Array([0, 0, 0]);
        _this.horizontalPass = horizonal;
        return _this;
    }
    Object.defineProperty(BlurTask.prototype, "name", {
        get: function () {
            return "FilterBlurTask:".concat((this.horizontalPass ? 'hor' : 'vert'), ":").concat(this._kernel);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurTask.prototype, "stepSize", {
        get: function () {
            return this._stepSize;
        },
        set: function (value) {
            if (this._stepSize == value)
                return;
            this._stepSize = value;
            this.calculateStepSize();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurTask.prototype, "kernel", {
        get: function () {
            return this._kernel;
        },
        set: function (value) {
            if (this._kernel == Math.round(value))
                return;
            this._kernel = Math.round(value);
            this._clampedKernel = this._kernel > 2
                ? Math.min(BlurTask.MAX_AUTO_SAMPLES, this._kernel)
                : 2;
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    BlurTask.prototype.getFragmentCode = function () {
        var kernel = this._clampedKernel;
        var hor = this.horizontalPass;
        var body = [];
        var gaus = BlurTask.KERNEL_GAUSIAN[kernel];
        var len = gaus.length;
        //let count = 1;
        for (var i = 0; i < kernel; i++) {
            var kernelValueIndex = i >= len ? kernel - i - 1 : i;
            var value = gaus[kernelValueIndex].toFixed(6);
            var offsetValue = ((2 * i + 1 - kernel)).toFixed(6);
            var offset = hor ? "vec2(".concat(offsetValue, ", 0.0)") : "vec2(0.0, ".concat(offsetValue, ")");
            body.push("\n\t\t\t\tcolor += texture2D(fs0, uv + uBlurData[1] * ".concat(offset, ") * ").concat(value, ";\n\t\t\t"));
        }
        return "\n\t\t\tprecision highp float;\n\t\t\tuniform vec3 uBlurData;\n\t\t\tuniform sampler2D fs0;\n\n\t\t\tvarying vec2 vUv;\n\t\t\t\n\t\t\tvoid main() {\n\t\t\t\tvec2 uv = vUv.xy;\n\t\t\t\tvec4 color = vec4(0.0);\n\n\t\t\t\t".concat(body.join('\n'), "\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}\n\t\t");
    };
    BlurTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var program = this._program3D;
        _stage.abstractions.getAbstraction(this._source).activate(0);
        program.uploadUniform('uTexMatrix', this._vertexConstantData);
        program.uploadUniform('uBlurData', this._data);
    };
    BlurTask.prototype.preActivate = function (_stage) {
        this.updateBlurData();
    };
    BlurTask.prototype.updateBlurData = function () {
        var size = this.horizontalPass
            ? this._source.width / this.imageScale
            : this._source.height / this.imageScale;
        this._data[0] = this._kernel * .5 / size;
        this._data[1] = this._realStepSize / size;
    };
    BlurTask.prototype.calculateStepSize = function () {
        if (this._stepSize > 0) {
            this._realStepSize = this._stepSize;
            return;
        }
        this._realStepSize = 0;
    };
    BlurTask.KERNEL_GAUSIAN = {
        1: [0.5],
        2: [0.5],
        3: [0.25, 0.5],
        4: [0.25, 0.25],
        5: [0.153388, 0.221461, 0.250301],
        6: [0.071303, 0.131514, 0.189879, 0.214607],
        7: [0.071303, 0.131514, 0.189879, 0.214607],
        8: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
        9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
        10: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
        11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
        12: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
        13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
        14: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448],
        15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448],
    };
    BlurTask.MAX_AUTO_SAMPLES = 15;
    return BlurTask;
}(TaskBaseWebGL /*Filter3DTaskBase*/));
export { BlurTask };
